module.exports = __webpack_public_path__ + "media/7.7f67f591.mp3";